<template>
  <div class="nx-form-bound-field">
    <v-layout row wrap>
      <component
        ref="field"
        :is="preparedFieldConfig.component"
        :label="preparedFieldConfig.label"
        :name="preparedFieldConfig.name"
        :value="fieldValue"
        :validation="preparedFieldConfig.validation"
        :disabled="disabled || preparedFieldConfig.params.disabled"
        v-bind="preparedFieldConfig.params"
        @input="unboundField"
      ></component>
      <v-tooltip bottom v-show="value">
        <v-btn slot="activator" large flat icon color="primary" @click="unboundField">
          <v-icon medium>fa-link</v-icon>
        </v-btn>
        <span v-html="$t('message.form.unboundField')"></span>
      </v-tooltip>
      <v-tooltip bottom v-show="!value">
        <v-btn slot="activator" large flat icon color="secondary" @click="boundField">
          <v-icon medium>fa-unlink</v-icon>
        </v-btn>
        <span v-html="$t('message.form.boundField')"></span>
      </v-tooltip>
    </v-layout>
  </div>
</template>

<script>
import PrepareFieldsConfig from '@/modules/form/mixins/prepare-fields-config';
import FormElement from '@/modules/form/mixins/form-element';

export default {
  name: 'nx-form-bound-field',
  mixins: [PrepareFieldsConfig, FormElement],
  props: {
    disabled: Boolean,
    value: {
      type: Boolean,
    },
    fieldConfig: {
      type: Object,
      required: true,
    },
    defaultValueFromField: {
      type: String,
    },
    formValue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    key() {
      return `bound-field.${this.field}`;
    },
    field() {
      return this.fieldConfig.field;
    },
    fieldValue() {
      return this.formValue[this.field];
    },
    preparedFieldConfig() {
      return this.prepareFieldConfig(this.fieldConfig, this.key, this.scope);
    },
  },
  methods: {
    async boundField() {
      if (this.defaultValueFromField && this.formValue[this.defaultValueFromField]) {
        this.$parentForm.updateField(this.field, this.formValue[this.defaultValueFromField]);
      }
      this.$parentForm.updateField(this.name, true);
      this.$nextTick(this.$refs.field.validate);
    },
    async unboundField() {
      this.$parentForm.updateField(this.name, false);
    },
  },
};
</script>
